export enum UserType {
    va = 'va',
    customer = 'customer',
    stylist = 'stylist',
    admin = 'admin',
}
export interface IAlgoliaUser {
    objectID: string;
    level?: any;
    email?: string;
    firstName?: string;
    lastName?: string;
    approved?: boolean;
    userType?: UserType;
    createdTimestamp?: number;
    featured?: number;
    id?: string;
    creator?: string;
    created?: string;
    updater?: string;
    updated?: string;
    phone?: string;
    gender?: string;
    userName?: string;
    bio?: string;
    profileImageUrl?: string;
}
